module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px",
      "height": "auto !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Client Department Details")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.goToMain
    }
  }, [_vm._v("Add Dept")])], 1), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "size": "sm",
      "disabled": _vm.ExcelBtnName != 'Export as Excel' ? true : false,
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.viewClientDetail('Excel')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName != 'Export as Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "text-muted pull-right mt-2 ml-3"
  }, [_c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")])])]), _vm._v(" "), _c('div', [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type To Search"
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": function($event) {
        _vm.filter = ''
      }
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.clientListView,
      "fields": _vm.fields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "clientId",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "clientName",
      fn: function(row11) {
        return [_c('div', {
          staticClass: "showMoreData",
          style: (row11.item.isKYC != 'Yes' ? 'color:red' : ''),
          on: {
            "click": function($event) {
              _vm.updateClientDept(row11.item.clientId)
            }
          }
        }, [_c('span', [_vm._v(_vm._s(row11.item.clientName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h6', [(row11.item.isKYC != 'Yes') ? _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v("Kyc Not Done")]) : _vm._e()], 1)])]
      }
    }, {
      key: "phoneKYC",
      fn: function(row1) {
        return [_c('span', [_vm._v("Contact No. : " + _vm._s(row1.item.phoneKYC))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Email-Address : " + _vm._s(row1.item.email))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Alternate Email-Addr : " + _vm._s(row1.item.altMail))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n              Corporate Address : " + _vm._s(row1.item.corporateAddress) + "\n              "), _c('br'), _vm._v("\n              " + _vm._s(row1.item.stateName) + "\n            ")])]
      }
    }, {
      key: "status",
      fn: function(row3) {
        return [_c('b-button', {
          attrs: {
            "variant": "outline-danger",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.updateClientDept(row3.item.clientId)
            }
          }
        }, [_vm._v("\n              " + _vm._s(row3.item.dept_type && row3.item.dept_type != "" ?
          "Completed" :
          "Pending") + "\n            ")])]
      }
    }, {
      key: "clientIsActive",
      fn: function(row3) {
        return [_c('b-button', {
          attrs: {
            "variant": "outline-danger",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.deleteClientDept(row3.item.clientId)
            }
          }
        }, [_c('md-icon', [_vm._v("delete_sweep")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "5",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "center"
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c05bf9c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/clients/viewClientDept.vue
// module id = 2606
// module chunks = 0